import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { createUseStyles } from "react-jss";
import { useSelector } from "react-redux";
import TravellerForm from "./TravellerForm";
import { v4 } from "uuid";
import jssVariables from "../../../jss_setup";

const travellersFormsStyles = createUseStyles({
  forms: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    overflowY: "auto",
    overflowX: "clip",
    height: "max-content",
    gridAutoFlow: "row",
    gridAutoRows: "max-content",
    ..._.get(props, "customStyles.forms", {}),
  }),
  form: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    ..._.get(props, "customStyles.form", {}),
  }),
  guestHeader: (props) => ({
    fontSize: "large",
    fontWeight: "bold",
    ..._.get(props, "customStyles.guestHeader", {}),
  }),
  divider: (props) => ({
    height: `calc(${jssVariables.normal_gap} / 4)`,
    width: "100%",
    background: jssVariables.colors.base_color,
    margin: `calc(${jssVariables.normal_gap} * 1) 0`,
    ..._.get(props, "customStyles.divider", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    forms: (props) => ({
      gridAutoFlow: "unset",
      maxHeight: "70vh",
      width: "max-content",
      ..._.get(props, "customStyles.forms.smallscreen", {}),
    }),
    form: (props) => ({
      display: "grid",
      gridGap: jssVariables.normal_gap,
      ..._.get(props, "customStyles.form.smallscreen", {}),
    }),
    divider: (props) => ({
      display: "none",
      ..._.get(props, "customStyles.divider.smallscreen", {}),
    }),
  },
});
const TravellersForms = ({ guests, setGuests }) => {
  const search_form = useSelector((state) => state.TransfersSearchForm);
  const { adults, children } = search_form;

  const classes = travellersFormsStyles({});

  return (
    <div className={classes.forms}>
      {[...Array(adults)].map((x, idx) => (
        <TravellerForm
          key={idx}
          idx={idx}
          type="ADT"
          group_leader={idx === 0}
          guest_id={`ADT_${idx}`}
          guest_uid={v4()}
          guests={guests}
          setGuests={setGuests}
        />
      ))}
      {[...Array(children)].map((x, idx) => (
        <TravellerForm
          key={idx}
          idx={idx}
          type="CHD"
          guest_id={`CHD_${idx}`}
          guest_uid={v4()}
          guests={guests}
          setGuests={setGuests}
        />
      ))}
    </div>
  );
};
TravellersForms.defaultProps = {
  guests: [],
};
TravellersForms.propTypes = {
  guests: PropTypes.array.isRequired,
  setGuests: PropTypes.func.isRequired,
};

export default TravellersForms;
